import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('grupos'), { params });
};

const getPadres = async () => {
  return await axiosIns.get(obtenerUrl('grupos/padres'));
};

const getConSubgrupos = async () => {
  return await axiosIns.get(obtenerUrl('grupos/subgrupos'));
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('grupos'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`grupos/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`grupos/${id}`));
};

export default {
  get,
  getPadres,
  getConSubgrupos,
  store,
  update,
  destroy,
};
